import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        getConcepts(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/payments-concepts',
                    method: 'GET',
                    params: params
                }).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
        },
        createConcept(obj, request) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/payments-concepts',
                    data: request,
                    method: 'POST'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        updateConcept(obj, { id, request }) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/payments-concepts/' + id,
                    data: request,
                    method: 'PUT'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        deleteConcept(obj, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/payments-concepts/' + id,
                    method: 'DELETE'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
    }
}